import { render, staticRenderFns } from "./Birds.vue?vue&type=template&id=7e1a73ea&scoped=true&"
import script from "./Birds.vue?vue&type=script&lang=js&"
export * from "./Birds.vue?vue&type=script&lang=js&"
import style0 from "./Birds.vue?vue&type=style&index=0&id=7e1a73ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1a73ea",
  null
  
)

export default component.exports